<template>
  <div ref="chart" style="width: 100%; height: 400px">
    <!-- 使用prop控制加载动画 -->
    <div v-if="loading" class="echarts-loading"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import ECharts from "vue-echarts";

export default {
  components: {
    "v-chart": ECharts,
  },
  data() {
    return {
      chart: null,
    };
  },
  props: {
    // 传配置项option
    option: {
      type: Object,
      default() {
        return {
          elementResize: "",
        };
      },
    },
    loading: {
      // 新增loading prop
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "400px",
    },
  },
  watch: {
    option() {
      if (this.chart) {
        this.chart.setOption(this.option); // 设置对应配置项
      }
    },
    loading(newValue) {
      if (this.chart) {
        // 根据loading值来切换ECharts内置的loading状态
        newValue ? this.chart.showLoading() : this.chart.hideLoading();
      }
    },
  },
  mounted() {
    // 创建ECharts实例并绑定到DOM
    this.chart = echarts.init(this.$refs.chart);
    this.chart.setOption(this.option);

    this.loading &&
      this.chart.showLoading({
        // 显示ECharts自带的加载动效，并设置背景为透明
        text: "Loading...",
        color: "#EFC394 ",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0)",
        zlevel: 0,
      }); // 如果初始化时loading为true，则显示加载动态效果
    window.addEventListener("resize", this.chart.resize);
    // 监听鼠标移动事件
    this.chart.on("mousemove", this.handleMouseMove);
  },
  methods: {
    handleMouseMove(params) {
      // 在鼠标移动时获取当前位置的指标数据
      const dataIndex = params.dataIndex;
      const value1 = this.chartOptions.series[0].data[dataIndex];
      const value2 = this.chartOptions.series[1].data[dataIndex];
      console.log(`指标1：${value1}, 指标2：${value2}`);
    },
  },
  beforeDestroy() {
    // 在组件销毁前解绑鼠标移动事件
    this.chart.off("mousemove", this.handleMouseMove);
  },
};
</script>